module.exports = __webpack_public_path__ + "ft-green-steps.30b7f825.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/ft-green-steps.jpg
// module id = 655
// module chunks = 0